export default __webpack_public_path__ + "static/media/236.0f121564.gif";